import { useEffect, useState } from "react";
import { errorText } from "../../inquiry/v6Api";

const LOADING = { loading: true, error: null, data: null };

// 블록 하나의 읽기 상태. key(기간)가 바뀌면 다시 읽고, 그 전 요청의 늦은 응답은 버린다.
export default function useBlock(load, key) {
    const [st, setSt] = useState(LOADING);
    useEffect(() => {
        let alive = true;
        setSt(LOADING);
        load().then(
            (data) => { if (alive) setSt({ loading: false, error: null, data }); },
            (e) => { if (alive) setSt({ loading: false, error: errorText(e), data: null }); },
        );
        return () => { alive = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
    return st;
}

// 읽는 중·오류를 그 블록 안에서만 보인다
export function Blk({ st, children, pad = 24 }) {
    if (st.loading) return <div className="empty" style={{ padding: `${pad}px 0` }}>불러오는 중…</div>;
    if (st.error) {
        return (
            <div className="empty" role="alert" style={{ padding: `${pad}px 0`, color: "#dc2626" }}>
                <i className="fa-solid fa-triangle-exclamation"></i> {st.error}
            </div>
        );
    }
    return children(st.data);
}

export const Qm = ({ n, l, f }) => (
    <div className="qm"><div className="n">{n}</div><div className="l">{l}</div><div className="f">{f}</div></div>
);
